// @flow
import React, { Component } from "react";
import Select, { Creatable } from "react-select";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Chip from "@material-ui/core/Chip";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ClearIcon from "@material-ui/icons/Clear";

import { ChipInputBase } from "imagus-components";

class Option extends Component<*> {
  handleClick = (event: Event): Function => {
    this.props.onSelect(this.props.option, event);
  };

  render(): * {
    const { children, isFocused, isSelected, onFocus } = this.props;

    return (
      <MenuItem
        onFocus={onFocus}
        selected={isFocused}
        onClick={this.handleClick}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400
        }}
      >
        {children}
      </MenuItem>
    );
  }
}

export const WrapperProps = (props: *): * => {
  const { classes, ...other } = props;

  return {
    optionComponent: Option,
    noResultsText: (
      <Typography variant="body2">{"No results found"}</Typography>
    ),
    arrowRenderer: (arrowProps: *): * => {
      return arrowProps.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
    },
    clearRenderer: (): * => <ClearIcon />,
    valueComponent: (valueProps: *): * => {
      const { value, children, onRemove } = valueProps;

      if (onRemove) {
        return (
          <Chip
            tabIndex={-1}
            label={children}
            className={classes.chip}
            onDelete={(event: Event): Function => {
              event.preventDefault();
              event.stopPropagation();
              onRemove(value);
            }}
          />
        );
      }

      return <div className="Select-value">{children}</div>;
    },
    ...other
  };
};

function SelectWrapped(props: *): * {
  return <Select {...WrapperProps(props)} />;
}

function SelectWrappedCreatable(props: *): * {
  return <Creatable {...WrapperProps(props)} />;
}

class ChipInput extends Component<*> {
  render(): * {
    const { allowCreate, ...other } = this.props;

    return (
      <ChipInputBase
        selectComponent={allowCreate ? SelectWrappedCreatable : SelectWrapped}
        {...other}
      />
    );
  }
}

export default ChipInput;
